export default "__VITE_ASSET__BW5ICt9L__"